<template>
  <settings-menu-layout>
    <manage-labels></manage-labels>
  </settings-menu-layout>
</template>

<script>
  import LoadSettingsMixin from "@/mixins/LoadSettingsMixin";
  import SettingsMenuLayout from "@/components/layout/SettingsMenuLayout";
  import ManageLabels from "@/pages/ManageLabels";

  export default {
    name: "SettingsLabels",
    mixins: [LoadSettingsMixin],
    data() {
      return {
      }
    },
    methods: {
      set_loading(loading) {
        this.loading = loading
      },
      select_item(page) {
        this.selected_page = page
      },
    },
    components: {
      ManageLabels,
      SettingsMenuLayout},
    mounted() {
    },
  }
</script>

<style scoped>

</style>